// extracted by mini-css-extract-plugin
export var centerText = "_el-8";
export var container = "_el-0";
export var doughnutContainer = "_el-7";
export var legend = "_el-a";
export var legendItemColorDisplay = "_el-b";
export var legendItemLabel = "_el-d";
export var legendItemValue = "_el-c";
export var lg = "_el-5";
export var maxWidth = "_el-9";
export var md = "_el-4";
export var responsive = "_el-6";
export var sm = "_el-3";
export var xs = "_el-2";
export var xxs = "_el-1";